<template>
  <div v-if="list_articles && list_articles.length > 0">
    <v-row>
      <v-col>
        <h3 class="font-weight-bold"><v-icon icon="mdi-basket-outline" color="primary" size="xs-small"></v-icon> La
          boutique</h3>
      </v-col>
    </v-row>
    <ArticleItem :article="article" v-for="article in list_articles" :key="article.id"></ArticleItem>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ArticleItem from "@/components/Home/Articles/Article_Item.vue";

export default {
  props: ["module_id"],
  components: { ArticleItem },
  data() {
    return {

    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_articles() {
      return this.mainStore.module.articles_boutique.visibles_accueil;
    }
  },

  methods: {

  },
  async created() {

  },
};
</script>

<style lang="scss" scoped></style>